import { Tooltip } from "@mui/joy";
import type { Training } from "../../api/training/Training.typed";

import { SInfo } from "../../styles/StyledMUI";
import DarkTypography from "./DarkTypography";
import { formatDate } from "../../utils/dateTime";
import { colorTokens } from "../../styles/globalStyles";

interface DetailsTooltipProps {
  training: Training;
}

export default function DetailsTooltip({ training }: DetailsTooltipProps) {
  return (
    <Tooltip
      sx={{
        bgcolor: colorTokens.bg.surface,
        color: colorTokens.text.primary,
      }}
      title={
        <>
          <DarkTypography level="body-sm" colorVariant="primary">
            Créée à : {formatDate(training.CreatedAt)}
          </DarkTypography>
          <DarkTypography level="body-sm" colorVariant="primary">
            Mise à jour à : {formatDate(training.UpdatedAt)}
          </DarkTypography>
          <DarkTypography level="body-sm" colorVariant="primary">
            Mise à jour par : {training.UpdatedBy || "N/A"}
          </DarkTypography>
        </>
      }
    >
      <SInfo sx={{ color: colorTokens.text.muted }} />
    </Tooltip>
  );
}
